/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { parseCookie } from "../../payment/miscellaneous/parseCookie";

export function orderLineCount(): number | undefined {
  const cookieParsed = parseCookie(document.cookie);
  const count: string | undefined = cookieParsed["MkHcOrderLineCount"];

  return count === undefined ? undefined : Number(count);
}
